// extracted by mini-css-extract-plugin
module.exports = {"sideDrawer":"main_sideDrawer__nt-Eg","lang":"main_lang__1Yd7q","input":"main_input__2W_Cu","output":"main_output__2_JEK","topRow":"main_topRow__3TTLG"};